export default {
  "nl": {
    "dropzone": {
      "labels": {
        "cancelUpload": "Annuleer Upload",
        "cancelUploadConfirmation": "Ben je zeker dat je het uploaden wil stoppen?",
        "chooseCategory": "Klik om eerst een categorie te selecteren",
        "defaultMessage": "Klik of sleep documenten",
        "fallbackMessage": "Jouw browser ondersteunt geen drag'n'drop document uploads.",
        "fallbackText": "Gelieve het onderstaande formulier te gebruiken om jouw documenten te uploaden, zoals in de goede oude tijd.",
        "fileTooBig": "Bestand is te groot: ({{filesize}} MB). Maximum Bestandsgrootte: {{maxFilesize}} MB.",
        "invalidFileType": "Dit bestandsformaat wordt niet ondersteund.",
        "maxFilesExceeded": "Je kan geen documenten meer uploaden.",
        "removeFile": "Verwijder document",
        "responseError": "Server antwoordt met {{statusCode}} code.",
        "uploadConfirmation": "Upload gelukt.",
        "warningMaxFileSize": "Tot {max_files_size} MB elk"
      }
    }
  }
}